import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught", error, info);
  }
  reset = () => this.setState({ hasError: false, error: null });
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
          <h2 className="font-heading text-2xl font-bold">Algo salió mal en esta vista</h2>
          <p className="max-w-md text-sm text-muted-foreground">
            Ocurrió un error al renderizar este módulo. Puedes reintentar o recargar la página.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-lg bg-foreground px-4 py-2 text-sm font-medium text-background"
            data-testid="error-reload-button"
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
